import React from 'react';
import PropTypes from 'prop-types';

import { ContainerInput, Label, Input, Div } from './styles';
import ds from '../../utils/designSystem';

class DefaultInput extends React.Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();
  }

  focus() {
    if (this.input.current) this.input.current.focus();
  }

  clear() {
    if (this.input.current) this.input.current.value = '';
  }

  onChangeValue = event => {
    const { onChange, type } = this.props;
    const { value } = event.target;

    if (type === 'password') {
      if (!/\s/.test(value)) {
        onChange(event);
      }
    } else {
      onChange(event);
    }
  };

  render() {
    const {
      label,
      placeholder,
      name,
      value,
      placeholderColor,
      width,
      error,
      ...props
    } = this.props;
    return (
      <ContainerInput error={error} width={width}>
        <Label error={error}>{label}</Label>
        <Div>
          <Input
            ref={this.input}
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={this.onChangeValue}
            placeholderColor={placeholderColor}
            {...props}
          />
        </Div>
      </ContainerInput>
    );
  }
}

DefaultInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.number,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholderColor: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

DefaultInput.defaultProps = {
  label: '',
  type: 'text',
  width: 90,
  name: '',
  placeholder: '',
  error: false,
  onChange: () => {},
  placeholderColor: ds.colors.gray
};

export default DefaultInput;
